import React, { useEffect } from 'react'
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { SpeedInsights } from "@vercel/speed-insights/react";
import { Analytics } from "@vercel/analytics/react";

import { initPerformanceOptimizations } from "@/utils/performanceOptimizer";
import { PostHogProvider } from "@/providers/PostHogProvider";
import { usePostHog } from "@/hooks/usePostHog";
import type { PageContext } from 'vite-plugin-ssr/types'
import './index.css'

const queryClient = new QueryClient();

export { PageShell }

function PageShellContent({ children, pageContext }: { children: React.ReactNode; pageContext: PageContext }) {
  const { posthog, isInitialized } = usePostHog();

  useEffect(() => {
    // Initialize performance optimizations
    initPerformanceOptimizations();
  }, []);

  useEffect(() => {
    // Track page views when route changes
    if (isInitialized && posthog) {
      posthog.capture('$pageview');
    }
  }, [pageContext.urlPathname, isInitialized, posthog]);

  return (
    <>
      <Toaster />
      <Sonner />
      <SpeedInsights />
      <Analytics />
      {children}
    </>
  );
}

function PageShell({ children, pageContext }: { children: React.ReactNode; pageContext: PageContext }) {
  return (
    <PostHogProvider>
      <QueryClientProvider client={queryClient}>
        <TooltipProvider>
          <PageShellContent pageContext={pageContext}>
            {children}
          </PageShellContent>
        </TooltipProvider>
      </QueryClientProvider>
    </PostHogProvider>
  )
}
